import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/kr1tAmQu43YLunWY8i225F/ChatGPT-Image-8-jul-2026_-09_50_12-p.m..webp';
export function FinalCTA() {
  return <section className="py-10 px-4 sm:px-6 bg-brand-navy text-white border-t-4 border-brand-gold text-center" data-id="element-42">
      <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-3" data-id="element-43">
        Un'Ultima Occasione
      </p>

      <div className="text-base sm:text-lg font-medium mb-6 leading-relaxed max-w-xl mx-auto text-white/90 space-y-3" data-id="element-44">
        <p data-id="element-45">
          I tuoi ginnasti meritano allenamenti preparati con cura, non lezioni
          organizzate all'ultimo momento perché non hai avuto tempo.
        </p>
        <p data-id="element-46">
          Smetti di passare ore a creare allenamenti, cercare esercizi,
          preparare progressioni e pianificare la stagione ogni settimana.
        </p>
        <p data-id="element-47">
          Smetti di perdere tempo tra libri, PDF, video, appunti e materiali
          sparsi ovunque.
        </p>
        <p data-id="element-48">
          Inizia a guidare ogni allenamento con sicurezza, organizzazione e un
          sistema professionale costruito per aiutare i tuoi ginnasti a
          migliorare più velocemente.
        </p>
        <p className="font-bold text-white" data-id="element-49">
          Regalati il sistema completo che avresti voluto avere fin dal tuo
          primo giorno da allenatore.
        </p>
      </div>

      <a href="#pricing" className="block cursor-pointer mb-6" data-id="element-50">
        <img src={PRODUCT_IMG} alt="GINNASTICA PRO - Box Set" className="w-full max-w-[280px] mx-auto object-contain drop-shadow-2xl" data-id="element-51" />
      </a>

      <div className="bg-white/5 border border-white/10 rounded-xl p-4 mb-6 shadow-lg max-w-sm mx-auto" data-id="element-52">
        <p className="text-sm sm:text-base font-heading font-bold mb-1 uppercase tracking-wide text-white/90" data-id="element-53">
          🤸 GINNASTICA PRO™ — Sistema Completo 6-in-1 + 5 Bonus Premium
        </p>
        <p className="text-lg line-through opacity-60 mb-1" data-id="element-54">
          Prezzo di Listino: 97€
        </p>
        <p className="text-4xl font-heading font-extrabold text-brand-gold leading-none" data-id="element-55">
          Oggi Solo: 27€
        </p>
      </div>

      <div className="mb-3" data-id="element-56">
        <CTAButton href="#pricing" variant="gold" data-id="element-57">
          🚀 SÌ! VOGLIO GINNASTICA PRO™
        </CTAButton>
      </div>

      <p className="text-xs font-bold text-white/80 mb-4 uppercase tracking-wide" data-id="element-58">
        Accesso Immediato • Consegna Istantanea via Email
      </p>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-[11px] sm:text-xs font-bold text-white/80" data-id="element-59">
        <div className="flex items-center gap-1.5" data-id="element-60">
          <Zap className="w-4 h-4 text-brand-gold" data-id="element-61" />
          <span data-id="element-62">Accesso Immediato</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-63">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-64" />
          <span data-id="element-65">4.9/5 — Recensioni Verificate</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-66">
          <Shield className="w-4 h-4 text-brand-gold" data-id="element-67" />
          <span data-id="element-68">Garanzia 14 Giorni</span>
        </div>
      </div>
    </section>;
}